import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls window to top whenever the route pathname changes. Mount this once
// inside <BrowserRouter> so every navigation lands at the page header.
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
